// src/components/themes/default/store/branch/BranchCategoryBubbles.tsx
import { Layers } from "lucide-react";

interface BranchCategoryBubblesProps {
  categories: any[];
  selectedCategory: string;
  onSelectCategory: (catId: string) => void;
}

export default function BranchCategoryBubbles({
  categories = [],
  selectedCategory,
  onSelectCategory,
}: BranchCategoryBubblesProps) {
  if (categories.length === 0) return null;

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 pt-8 space-y-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Layers className="w-4 h-4 text-emerald-600" />
          <h3 className="text-base sm:text-lg font-black text-slate-900">
            Explore Categories
          </h3>
        </div>
        <span className="text-xs font-bold text-slate-400">
          {categories.length} Collections
        </span>
      </div>

      <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8 gap-3">
        <button
          onClick={() => onSelectCategory("all")}
          className={`p-3 rounded-2xl flex flex-col items-center justify-center gap-2 transition-all border cursor-pointer ${
            selectedCategory === "all"
              ? "bg-emerald-50 border-emerald-500 text-emerald-700 font-black shadow-sm"
              : "bg-white border-slate-200 hover:border-slate-300 text-slate-700"
          }`}
        >
          <div className="w-10 h-10 rounded-xl bg-slate-100 flex items-center justify-center text-lg">
            🛒
          </div>
          <span className="text-xs font-bold truncate max-w-full">All Items</span>
        </button>

        {categories.map((cat) => {
          const isSelected =
            selectedCategory === String(cat.id) || selectedCategory === cat.slug;

          return (
            <button
              key={cat.id}
              onClick={() => onSelectCategory(String(cat.id))}
              className={`p-3 rounded-2xl flex flex-col items-center justify-center gap-2 transition-all border cursor-pointer ${
                isSelected
                  ? "bg-emerald-50 border-emerald-500 text-emerald-700 font-black shadow-sm"
                  : "bg-white border-slate-200 hover:border-slate-300 text-slate-700"
              }`}
            >
              <div className="w-10 h-10 rounded-xl bg-slate-100 flex items-center justify-center text-lg overflow-hidden">
                {cat.image ? (
                  <img src={cat.image} alt={cat.name} className="w-full h-full object-cover" />
                ) : (
                  cat.icon || "📦"
                )}
              </div>
              <span className="text-xs font-bold truncate max-w-full">{cat.name}</span>
            </button>
          );
        })}
      </div>
    </section>
  );
}